{
  "comment": "M4 hulls (spec §4.6, §6.4, §8.2). Build costs are component wares only (a schema refinement), plus the refractory alloy in the gunship (2 t), hauler_large (8 t) and corvette (12 t) since 5(e) (U7, MC-e3, T33: the alloy's AI sink; yards stock it through shipyard.buysPerLevel; hulk kits and scrap read only the component tier, T52), set so the yard price (Σ buildCost × S(fill) × priceMargin) is about the M6 price table. shipDef: the local M1/M2 ship def the traffic layer spawns; patrolShipDef: the def patrols of this hull use (M3 draft patrol_interceptor / patrol_gunship), null = shipDef. escort: the hull can escort convoys. cargo in tonnes; strength and toughness drive out-of-system combat; buildSeconds at a yard slot; wreckLayout: M2's salvage.json layout id for off-screen wrecks. M5 (C10, M5 spec §9.2): guardian_interceptor is the guardian cell's hull, the interceptor's values on M3's guardian_interceptor ship def; it flies the raider role (the cell reuses M4's raid groups under faction guardian; ROLE has no guardian code) and no roles.json mix names it, so M4 job fill never builds it. M5 (C6, M5 spec §21): cutter is the Charter cutter, the Authority's patrol and escort hull (strength 5, toughness 5, build cost at the gunship's scale) on the ship.cutter greybox and the cutter ship def (PDC turrets). Starting values, tune freely. M6 (plan P5): the player-buyable hulls carry class (one hull per fleet.json class; cargo inside the class hold range), crew and standingReq (the pilot's standing with the yard's faction needed to buy; absent = none). light_fighter (the Kestrel line, ship def kestrel), salvager, hauler_large and corvette are player-only: no roles.json mix names them, so M4 job fill never builds them, and their ship defs (salvager, hauler_large, corvette) come with the M6 placeholders (P19); their build costs put the yard price at about the M6 spec §4 price at mid fill. Appended so the M4/M5 hull indices are unchanged. yard: Balance pass T4 (plan §2.5, D-314 D1): AI orders are paid on delivery; a queued order missing components is passed over until it has waited skipAheadMaxWaitDays; build times x buildTimeMult (yards built about 1.3-3 ships a day against 4-6 orders a day). ownerFirst: the yard owner's own ready orders start first (Varro's free orders no longer queue behind everyone's). Schema defaults are off (false, false, 5, 1, false). T4 part 2 turns them on: pay on delivery (placeOrder then needs treasury minus open dues >= price), skip-ahead 5 d, buildTimeMult 0.8 (0.7 pinned fuel_cells on M4 g21; the yards are component-limited) and ownerFirst; see docs/research/raw/2026-09-29-balance-t4.md. yardQueue.holdMaxDays (SUP-1b, D-743; [P]): an aged order (ownerFirstMaxAgeDays) missing components holds its yard at most this many days (0 = no cap), then stops holding but keeps first claim whenever its bill is in stock; it backstops a hold that never releases (no cancel path for a paid player order) and sits at the soak report's 30-day no-start bound. yardQueue.withholdAgedBill (M10 P4a7e, D-TBD): a yard withholds its aged orders' bill (the largest cost per ware among queued orders aged ownerFirstMaxAgeDays) from sale, so its own trading post no longer sells the plating an aged order waits on; the surplus above the bill still sells. false reads P4a7d.",
  "priceMargin": 1.15,
  "yard": {
    "payOnDelivery": true,
    "skipAhead": true,
    "skipAheadMaxWaitDays": 5,
    "buildTimeMult": 0.8,
    "ownerFirst": true
  },
  "yardQueue": {
    "enabled": true,
    "loadHops": 1,
    "ownerFirstMaxAgeDays": 20,
    "maxOpenOrdersPerFaction": 10,
    "holdMaxDays": 30,
    "withholdAgedBill": true
  },
  "hulls": [
    {
      "id": "hauler",
      "shipDef": "hauler",
      "patrolShipDef": null,
      "roles": [
        "trader",
        "supplier",
        "convoy",
        "constructor"
      ],
      "escort": false,
      "cargo": 300,
      "strength": 0.5,
      "toughness": 4,
      "buildCost": {
        "hull_plating": 80,
        "drive_parts": 20,
        "electronics": 16,
        "weapon_parts": 4
      },
      "buildSeconds": 1800,
      "wreckLayout": "hauler",
      "class": "hauler",
      "crew": 2,
      "band": "M",
      "line": "meridian.hauler",
      "maker": "meridian",
      "tollClass": "medium",
      "export": true
    },
    {
      "id": "miner",
      "shipDef": "miner",
      "patrolShipDef": null,
      "roles": [
        "miner"
      ],
      "escort": false,
      "cargo": 120,
      "strength": 0.3,
      "toughness": 3,
      "buildCost": {
        "hull_plating": 60,
        "drive_parts": 16,
        "electronics": 14,
        "weapon_parts": 2
      },
      "buildSeconds": 1500,
      "wreckLayout": "miner",
      "class": "miner",
      "crew": 2,
      "band": "M",
      "line": "tethys.miner",
      "maker": "tethys",
      "tollClass": "medium",
      "export": true
    },
    {
      "id": "interceptor",
      "shipDef": "interceptor",
      "patrolShipDef": "patrol_interceptor",
      "roles": [
        "patrol",
        "raider"
      ],
      "escort": false,
      "cargo": 10,
      "strength": 3,
      "toughness": 2,
      "buildCost": {
        "hull_plating": 20,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 6
      },
      "buildSeconds": 900,
      "wreckLayout": "interceptor",
      "class": "interceptor",
      "crew": 1,
      "standingReq": 10,
      "band": "S",
      "line": "varro_security.interceptor",
      "maker": "varro_security",
      "tollClass": "light",
      "export": true
    },
    {
      "id": "gunship",
      "shipDef": "gunship",
      "patrolShipDef": "patrol_gunship",
      "roles": [
        "patrol",
        "raider"
      ],
      "escort": true,
      "cargo": 20,
      "strength": 6,
      "toughness": 5,
      "buildCost": {
        "hull_plating": 40,
        "drive_parts": 10,
        "electronics": 8,
        "weapon_parts": 12,
        "refractory_alloy": 2
      },
      "buildSeconds": 1200,
      "wreckLayout": "gunship",
      "class": "gunship",
      "crew": 1,
      "standingReq": 20,
      "band": "S",
      "line": "varro_security.gunship",
      "maker": "varro_security",
      "tollClass": "medium",
      "export": true
    },
    {
      "id": "guardian_interceptor",
      "shipDef": "guardian_interceptor",
      "patrolShipDef": null,
      "roles": [
        "raider"
      ],
      "escort": false,
      "cargo": 10,
      "strength": 3,
      "toughness": 2,
      "buildCost": {
        "hull_plating": 20,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 6
      },
      "buildSeconds": 900,
      "wreckLayout": "interceptor",
      "band": "S",
      "tollClass": "medium",
      "story": true
    },
    {
      "id": "cutter",
      "shipDef": "cutter",
      "patrolShipDef": null,
      "roles": [
        "patrol"
      ],
      "escort": true,
      "cargo": 20,
      "strength": 5,
      "toughness": 5,
      "buildCost": {
        "hull_plating": 40,
        "drive_parts": 10,
        "electronics": 10,
        "weapon_parts": 10
      },
      "buildSeconds": 1200,
      "wreckLayout": "cutter",
      "class": "patrol",
      "band": "M",
      "line": "authority.patrol",
      "maker": "authority",
      "tollClass": "medium",
      "sale": false
    },
    {
      "id": "light_fighter",
      "shipDef": "kestrel",
      "patrolShipDef": null,
      "roles": [
        "trader",
        "patrol"
      ],
      "escort": false,
      "cargo": 30,
      "strength": 2,
      "toughness": 2,
      "buildCost": {
        "hull_plating": 22,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 5
      },
      "buildSeconds": 1000,
      "wreckLayout": "kestrel",
      "class": "light_fighter",
      "crew": 1,
      "band": "S",
      "line": "tethys.utility",
      "maker": "tethys",
      "tollClass": "medium"
    },
    {
      "id": "salvager",
      "shipDef": "salvager",
      "patrolShipDef": null,
      "roles": [
        "trader"
      ],
      "escort": false,
      "cargo": 80,
      "strength": 0.4,
      "toughness": 3.5,
      "buildCost": {
        "hull_plating": 70,
        "drive_parts": 18,
        "electronics": 20,
        "weapon_parts": 4
      },
      "buildSeconds": 1600,
      "wreckLayout": "salvager",
      "class": "salvager",
      "crew": 2,
      "band": "M",
      "line": "holdfast.salvager",
      "maker": "holdfast",
      "tollClass": "medium"
    },
    {
      "id": "hauler_large",
      "shipDef": "hauler_large",
      "patrolShipDef": null,
      "roles": [
        "trader",
        "supplier"
      ],
      "escort": false,
      "cargo": 900,
      "strength": 1,
      "toughness": 8,
      "buildCost": {
        "hull_plating": 240,
        "drive_parts": 50,
        "electronics": 48,
        "weapon_parts": 10,
        "refractory_alloy": 8
      },
      "buildSeconds": 3000,
      "wreckLayout": "hauler_large",
      "class": "hauler_large",
      "crew": 3,
      "standingReq": 10,
      "band": "L",
      "line": "meridian.hauler",
      "maker": "meridian",
      "tollClass": "large"
    },
    {
      "id": "corvette",
      "shipDef": "corvette",
      "patrolShipDef": null,
      "roles": [
        "patrol"
      ],
      "escort": true,
      "cargo": 60,
      "strength": 8,
      "toughness": 9,
      "buildCost": {
        "hull_plating": 260,
        "drive_parts": 90,
        "electronics": 80,
        "weapon_parts": 58,
        "refractory_alloy": 12
      },
      "buildSeconds": 3600,
      "wreckLayout": "corvette",
      "class": "corvette",
      "crew": 4,
      "standingReq": 40,
      "band": "M",
      "line": "varro_security.escort",
      "maker": "varro_security",
      "tollClass": "medium",
      "wingSize": 5
    },
    {
      "id": "prisoner_transport",
      "shipDef": "prisoner_transport",
      "patrolShipDef": null,
      "roles": [
        "trader"
      ],
      "escort": false,
      "cargo": 300,
      "strength": 0.5,
      "toughness": 4,
      "buildCost": {
        "hull_plating": 80,
        "drive_parts": 20,
        "electronics": 16,
        "weapon_parts": 4
      },
      "buildSeconds": 1800,
      "wreckLayout": "prisoner_transport",
      "crew": 2,
      "band": "M",
      "line": "authority.secure",
      "maker": "authority",
      "tollClass": "medium",
      "story": true
    },
    {
      "id": "voss_yacht",
      "shipDef": "voss_yacht",
      "patrolShipDef": null,
      "roles": [
        "trader"
      ],
      "escort": false,
      "cargo": 30,
      "strength": 2,
      "toughness": 2,
      "buildCost": {
        "hull_plating": 22,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 5
      },
      "buildSeconds": 1000,
      "wreckLayout": "voss_yacht",
      "crew": 1,
      "band": "S",
      "line": "tethys.halcyon",
      "maker": "tethys",
      "tollClass": "medium",
      "story": true,
      "unique": true
    },
    {
      "id": "meridian_courier",
      "shipDef": "meridian_courier",
      "patrolShipDef": null,
      "roles": [
        "trader"
      ],
      "escort": false,
      "cargo": 30,
      "strength": 2,
      "toughness": 2,
      "buildCost": {
        "hull_plating": 22,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 5
      },
      "buildSeconds": 1000,
      "wreckLayout": "meridian_courier",
      "class": "courier",
      "crew": 1,
      "band": "S",
      "line": "meridian.courier",
      "maker": "meridian",
      "tollClass": "medium",
      "sale": false
    },
    {
      "id": "tethys_gannet",
      "shipDef": "tethys_gannet",
      "patrolShipDef": null,
      "roles": [
        "miner"
      ],
      "escort": false,
      "cargo": 360,
      "strength": 0.95,
      "toughness": 9.2,
      "buildCost": {
        "hull_plating": 180,
        "drive_parts": 48,
        "electronics": 42,
        "weapon_parts": 6,
        "refractory_alloy": 6
      },
      "buildSeconds": 3000,
      "wreckLayout": "miner",
      "class": "miner",
      "crew": 8,
      "band": "L",
      "line": "tethys.miner",
      "maker": "tethys",
      "tollClass": "large",
      "sale": false,
      "lengthM": 120
    },
    {
      "id": "varro_warhound",
      "shipDef": "varro_warhound",
      "patrolShipDef": null,
      "roles": [
        "patrol"
      ],
      "escort": true,
      "cargo": 100,
      "strength": 20.16,
      "toughness": 18,
      "buildCost": {
        "hull_plating": 160,
        "drive_parts": 40,
        "electronics": 40,
        "weapon_parts": 40,
        "refractory_alloy": 2
      },
      "buildSeconds": 7200,
      "wreckLayout": "corvette",
      "class": "frigate",
      "crew": 12,
      "standingReq": 50,
      "band": "L",
      "line": "varro_security.escort",
      "maker": "varro_security",
      "tollClass": "large",
      "sale": false,
      "lengthM": 140
    },
    {
      "id": "tethys_skua",
      "shipDef": "tethys_skua",
      "patrolShipDef": null,
      "roles": [],
      "escort": false,
      "cargo": 240,
      "strength": 0.95,
      "toughness": 10.35,
      "buildCost": {
        "hull_plating": 180,
        "drive_parts": 45,
        "electronics": 50,
        "weapon_parts": 8
      },
      "buildSeconds": 3200,
      "wreckLayout": "salvager",
      "class": "salvager",
      "crew": 8,
      "band": "L",
      "line": "tethys.salvager",
      "maker": "tethys",
      "tollClass": "large",
      "sale": false,
      "lengthM": 110
    },
    {
      "id": "holdfast_picket",
      "shipDef": "holdfast_picket",
      "patrolShipDef": null,
      "roles": [
        "patrol"
      ],
      "escort": false,
      "cargo": 10,
      "strength": 2.85,
      "toughness": 2.1,
      "buildCost": {
        "hull_plating": 20,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 6
      },
      "buildSeconds": 900,
      "wreckLayout": "interceptor",
      "class": "interceptor",
      "crew": 1,
      "standingReq": 10,
      "band": "S",
      "line": "holdfast.interceptor",
      "maker": "holdfast",
      "tollClass": "light",
      "sale": false,
      "lengthM": 18
    },
    {
      "id": "holdfast_wayfinder",
      "shipDef": "holdfast_wayfinder",
      "patrolShipDef": null,
      "roles": [],
      "escort": false,
      "cargo": 20,
      "strength": 0.95,
      "toughness": 2.1,
      "buildCost": {
        "hull_plating": 20,
        "drive_parts": 8,
        "electronics": 10,
        "weapon_parts": 2
      },
      "buildSeconds": 1000,
      "wreckLayout": "kestrel",
      "class": "survey",
      "crew": 1,
      "band": "S",
      "line": "holdfast.survey",
      "maker": "holdfast",
      "tollClass": "light",
      "sale": false,
      "lengthM": 24
    },
    {
      "id": "holdfast_delver",
      "shipDef": "holdfast_delver",
      "patrolShipDef": null,
      "roles": [],
      "escort": false,
      "cargo": 120,
      "strength": 0.285,
      "toughness": 3.15,
      "buildCost": {
        "hull_plating": 60,
        "drive_parts": 16,
        "electronics": 14,
        "weapon_parts": 2
      },
      "buildSeconds": 1500,
      "wreckLayout": "miner",
      "class": "miner",
      "crew": 2,
      "band": "M",
      "line": "holdfast.miner",
      "maker": "holdfast",
      "tollClass": "medium",
      "sale": false,
      "lengthM": 66
    },
    {
      "id": "tethys_kt3p",
      "shipDef": "tethys_kt3p",
      "patrolShipDef": null,
      "roles": [],
      "escort": false,
      "cargo": 40,
      "strength": 1.9,
      "toughness": 2.3,
      "buildCost": {
        "hull_plating": 22,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 5
      },
      "buildSeconds": 1000,
      "wreckLayout": "kestrel",
      "class": "miner",
      "crew": 1,
      "band": "S",
      "line": "tethys.utility",
      "maker": "tethys",
      "tollClass": "medium",
      "sale": false
    },
    {
      "id": "varro_mastiff_b",
      "shipDef": "varro_mastiff_b",
      "patrolShipDef": null,
      "roles": [],
      "escort": true,
      "cargo": 40,
      "strength": 9,
      "toughness": 8.1,
      "buildCost": {
        "hull_plating": 260,
        "drive_parts": 90,
        "electronics": 80,
        "weapon_parts": 58,
        "refractory_alloy": 12
      },
      "buildSeconds": 3600,
      "wreckLayout": "corvette",
      "class": "bomber",
      "crew": 4,
      "standingReq": 40,
      "band": "M",
      "line": "varro_security.escort",
      "maker": "varro_security",
      "tollClass": "medium",
      "wingSize": 5,
      "sale": false
    },
    {
      "id": "relic_escort",
      "shipDef": "relic_escort",
      "patrolShipDef": null,
      "roles": [],
      "escort": false,
      "cargo": 10,
      "strength": 2.85,
      "toughness": 2.1,
      "buildCost": {
        "hull_plating": 20,
        "drive_parts": 8,
        "electronics": 6,
        "weapon_parts": 6
      },
      "buildSeconds": 900,
      "wreckLayout": "interceptor",
      "class": "interceptor",
      "crew": 1,
      "standingReq": 10,
      "band": "S",
      "line": "holdfast.interceptor",
      "maker": "holdfast",
      "tollClass": "light",
      "relic": true,
      "sale": false,
      "lengthM": 18
    },
    {
      "id": "relic_skiff",
      "shipDef": "relic_skiff",
      "patrolShipDef": null,
      "roles": [],
      "escort": false,
      "cargo": 20,
      "strength": 0.95,
      "toughness": 2.1,
      "buildCost": {
        "hull_plating": 20,
        "drive_parts": 8,
        "electronics": 10,
        "weapon_parts": 2
      },
      "buildSeconds": 1000,
      "wreckLayout": "kestrel",
      "class": "survey",
      "crew": 1,
      "band": "S",
      "line": "holdfast.survey",
      "maker": "holdfast",
      "tollClass": "light",
      "relic": true,
      "sale": false,
      "lengthM": 24
    },
    {
      "id": "relic_salvage_tug",
      "shipDef": "relic_salvage_tug",
      "patrolShipDef": null,
      "roles": [],
      "escort": false,
      "cargo": 80,
      "strength": 0.4,
      "toughness": 3.5,
      "buildCost": {
        "hull_plating": 70,
        "drive_parts": 18,
        "electronics": 20,
        "weapon_parts": 4
      },
      "buildSeconds": 1600,
      "wreckLayout": "salvager",
      "class": "salvager",
      "crew": 2,
      "band": "M",
      "line": "holdfast.salvager",
      "maker": "holdfast",
      "tollClass": "medium",
      "relic": true,
      "sale": false
    }
  ]
}
